import * as LDClient from 'launchdarkly-js-client-sdk';

/**
 * A singleton LaunchDarkly service to manage the client instance and its state.
 * It initializes the client with the provided client-side ID and user information,
 */
class LaunchDarklyService {
    constructor() {
        this.client = null;
        this.isReady = false;
        this.readyCallbacks = [];
        this.initializedUserKey = null;
        this.failed = false;
    }

    init(clientSideId, user, options = {}) {
        if (this.client && this.initializedUserKey === user.key) {
            return;
        }

        if (this.client) {
            this.client.close();
            this.isReady = false;
            this.readyCallbacks = [];
            this.failed = false;
        }

        this.client = LDClient.initialize(clientSideId, user, options);
        this.initializedUserKey = user.key;

        this.client.on('ready', () => {
            this.isReady = true;
            this.failed = false;
            this.readyCallbacks.forEach(cb => cb());
            this.readyCallbacks = [];
        });
        this.client.on('failed', (err) => {
            this.isReady = false;
            this.failed = true;
            this.readyCallbacks = [];
            console.error('LaunchDarkly initialization failed', err);
        });
    }

    onReady(callback) {
        if (this.isReady) callback();
        else if (!this.failed) this.readyCallbacks.push(callback);
        else console.warn('LaunchDarkly client failed to initialize.');
    }

    async getFlag(flagKey, fallback = false) {
        return new Promise(resolve => {
            this.onReady(() => {
                if (this.client) {
                    resolve(this.client.variation(flagKey, fallback));
                } else {
                    resolve(fallback);
                }
            });
        });
    }

    unsub(flagKey) {
        if (!this.client) {
            console.warn('LaunchDarkly client not initialized.');
            return;
        }
        this.client.off(`change:${flagKey}`);
    }

    subscribe(flagKey, callback) {
        if (!this.client) {
            console.warn('LaunchDarkly client not initialized.');
            return;
        }
        this.client.on(`change:${flagKey}`, changes => {
            callback(changes);
        });
    }
}

export default new LaunchDarklyService();
